import emailjs from '@emailjs/browser';

// EmailJS Configuration mit Gmail Service
const EMAILJS_SERVICE_ID = 'service_2b6fuqd'; // Deine Service ID aus dem Screenshot
const EMAILJS_TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'template_45v8n5t';
const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || '24mTBmT4ypqZ28GwZ';

// Initialize EmailJS
emailjs.init(EMAILJS_PUBLIC_KEY);

export const sendContactEmail = async (formData) => {
  try {
    // Check if EmailJS is properly configured
    if (!EMAILJS_PUBLIC_KEY || EMAILJS_PUBLIC_KEY === 'your_public_key') {
      console.warn('EmailJS Public Key not configured');
      return { 
        success: false, 
        message: 'E-Mail-Service ist noch nicht vollständig konfiguriert. Bitte Public Key setzen.',
        useMailto: true
      };
    }

    // Prepare template parameters for EmailJS
    const templateParams = {
      // Sender info (wird von Gmail gesendet)
      from_name: formData.name,
      from_email: formData.email,
      reply_to: formData.email,
      
      // Contact details
      phone: formData.phone || 'Nicht angegeben',
      company: formData.company || 'Nicht angegeben',
      competence: formData.competence || 'Nicht angegeben',
      topic: formData.topic,
      datetime: formData.datetime || 'Nicht angegeben',
      mode_type: formData.mode_type,
      
      // Recipient (wird an Tom gesendet)
      to_email: 'mail@tom-oppenhaeuser.com',
      to_name: 'Tom Oppenhäuser',
      
      // Metadata
      timestamp: new Date().toLocaleString('de-DE'),
      source: 'tomweb-contact-form',
      
      // Subject
      subject: `Neue Kontaktanfrage - ${formData.mode_type}`,
      
      // Formatted message for email body
      message: `
Neue Kontaktanfrage - ${formData.mode_type}

Name: ${formData.name}
E-Mail: ${formData.email}
Telefon: ${formData.phone || 'Nicht angegeben'}
${formData.company ? `Unternehmen: ${formData.company}` : ''}
Kompetenz: ${formData.competence || 'Nicht angegeben'}
Gewünschter Termin: ${formData.datetime || 'Nicht angegeben'}

Nachricht/Thema:
${formData.topic}

Anfrage-Typ: ${formData.mode_type}
Eingegangen am: ${new Date().toLocaleString('de-DE')}
      `.trim()
    };

    console.log('Sending email with EmailJS:', templateParams);

    const response = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID,
      templateParams
    );

    console.log('✅ Email sent successfully via EmailJS:', response);
    return { 
      success: true, 
      message: 'Vielen Dank für Ihre Anfrage! Ich melde mich zeitnah bei Ihnen zurück.' 
    };

  } catch (error) {
    console.error('❌ EmailJS failed:', error);
    return { 
      success: false, 
      message: 'Es gab ein technisches Problem beim Versenden Ihrer Nachricht.',
      useMailto: true
    };
  }
};

// Fallback: Create mailto link if EmailJS fails
export const createMailtoLink = (formData) => {
  const subject = encodeURIComponent(`Kontaktanfrage - ${formData.mode_type}`);
  const body = encodeURIComponent(`
Hallo Tom,

ich interessiere mich für ${formData.mode_type.toLowerCase()}.

Name: ${formData.name}
E-Mail: ${formData.email}
Telefon: ${formData.phone || 'Nicht angegeben'}
${formData.company ? `Unternehmen: ${formData.company}\n` : ''}
Kompetenz: ${formData.competence || 'Nicht angegeben'}
Gewünschter Termin: ${formData.datetime || 'Nicht angegeben'}

Nachricht/Thema:
${formData.topic}

Viele Grüße,
${formData.name}
  `.trim());

  return `mailto:mail@tom-oppenhaeuser.com?subject=${subject}&body=${body}`;
};
